/** Hero premium del link público (Eduardo 2026-09-10): el nombre del torneo
 * se parte en dos líneas y la segunda va en verde lima ("Torneo Round Robin"
 * / "Varonil Otoño 2026"). Mitad y mitad por palabras; con 3 palabras la
 * última; con 1-2 palabras no se parte. */
export function splitHeroTitle(name: string): { main: string; accent: string | null } {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length <= 2) return { main: words.join(" "), accent: null };
  const cut = words.length === 3 ? 2 : Math.floor(words.length / 2);
  return { main: words.slice(0, cut).join(" "), accent: words.slice(cut).join(" ") };
}
